import clsx from 'clsx';
import { IBlogItemOverview } from 'common/types/blog';
import { Keyboard, Mousewheel, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

import 'swiper/css/pagination';
import { BlogItemLatest } from '../BlogItemLatest';

export const BlogItemsLatest = ({
  blogs,
  dark = true,
}: {
  blogs: IBlogItemOverview[];
  dark: boolean;
}) => {
  const blogsWithSlug = blogs.filter(blog => typeof blog?.slug === 'string' && !!blog.slug);

  return (
    <section
      className={clsx('relative overflow-hidden pt-10', {
        'bg-gradient': dark,
        'bg-white': !dark,
      })}
      id="blogItemsLatest">
      <Swiper
        className="!pb-12"
        style={{ paddingLeft: 20, paddingRight: 20 }}
        spaceBetween={10}
        slidesPerView={1}
        modules={[Pagination, Keyboard, Mousewheel]}
        pagination={{ clickable: true }}
        keyboard={{ enabled: true }}
        mousewheel={{ forceToAxis: true }}
        breakpoints={{
          600: { slidesPerView: 1 },
          1020: { slidesPerView: 2.2 },
          1600: { slidesPerView: 3.2 },
          2200: { slidesPerView: 3.2 },
        }}>
        {!!blogsWithSlug.length &&
          blogsWithSlug.map((blog: IBlogItemOverview) => (
            <SwiperSlide key={blog.slug} style={{ height: 'auto' }}>
              <div className="h-full">
                <BlogItemLatest blog={blog} />
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </section>
  );
};

export default BlogItemsLatest;
